import { ReactElement } from 'react';
import { ZoomControl } from 'react-kakao-maps-sdk';

function ZoomController(): ReactElement {
  return <ZoomControl position={3} />;
}

export default ZoomController;
